var map = {
	"./BALANCE DE LABORATOIRE.png": 135,
	"./BIOLOGIE MOLECULAIRE.png": 136,
	"./EQUIPEMENT DE SÉCURITÉ LABORATOIRE.png": 137,
	"./EQUIPEMENT ET MATÉRIEL SCINTIFIQUE.png": 138,
	"./LOGO-1.png": 37,
	"./LOGO-2.png": 42,
	"./MICROBIOLOGIE.png": 139,
	"./PESAGE.png": 140,
	"./REACTIF ET PRODUIT CHIMIQUE.png": 141,
	"./VERRERIE ET CONSOMMABLE.png": 142,
	"./home-feature.png": 143,
	"./section-icon-6.png": 144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;